import { createFileRoute } from "@tanstack/react-router"
import type { CSSProperties } from "react"

import { marketingPages } from "@/lib/marketing-pages"
import { seoMeta } from "@/lib/seo"

import { IndiaCtaSection } from "./-components/IndiaCtaSection"
import { IndiaGlobeSection } from "./-components/IndiaGlobeSection"
import { IndiaHeroSection } from "./-components/IndiaHeroSection"
import { IndiaNetworkSection } from "./-components/IndiaNetworkSection"
import { IndiaTerminalsSection } from "./-components/IndiaTerminalsSection"

export const Route = createFileRoute("/about/india/")({
  head: () =>
    seoMeta({
      title: "Entire in India",
      description: marketingPages["/about/india"].description,
      url: "https://entire.com/about/india",
      image: "https://entire.com/images/og/india.png",
      imageAlt:
        "Entire social card with the message “The fastest Git Forge in India” above the Entire app.",
    }),
  component: IndiaPage,
})

function IndiaPage() {
  // Override the shared accent with warm orange for this page. Set the Tailwind
  // alias too: inherited aliases resolve where declared, so changing --accent
  // alone here would not update text-accent utilities.
  return (
    <div
      style={
        {
          "--accent": "#CD3D00",
          "--color-accent": "#CD3D00",
        } as CSSProperties
      }
    >
      <IndiaHeroSection />
      <IndiaGlobeSection />
      <IndiaNetworkSection />
      <IndiaTerminalsSection />
      <IndiaCtaSection />
    </div>
  )
}
